<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2oKszd/tc-custom/9781466844292.jpg?1721404702063" alt="This image is the cover for the book Accidental Apprentice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Accidental Apprentice
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Vikas Swarup, acclaimed author of <i>Slumdog Millionaire</i> and <i>Six Suspects,</i> has written a compelling, suspenseful tale about the lure of money and the power of dreams. <i>The Accidental Apprentice </i>is international crime fiction at its most entertaining.</b><br/><br/><i>In life you never get what you deserve. You get what you negotiate.<br/><br/></i>A business empire worth ten billion dollars. This is the tantalizing offer made by Vinay Mohan Acharya, one of India's richest men, to Sapna Sinha, a simple salesgirl in an electronics store in downtown Delhi. She can be the next CEO of his incredibly huge and profitable company. There is only one catch—she needs to pass seven tests from the "textbook of life."<br/><br/>Thus begins the most challenging journey Sapna has ever undertaken, one that will take her from her swanky showroom to the heat and dust of India's backstreets and villages. Along the way she encounters a host of memorable personalities, from a vain Bollywood superstar to a kleptomaniac Gandhian. But are the seven tests real or is Acharya playing a game driven by a perverse fantasy?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vikas Swarup
      </h2>
      
      <p class="authorDescription body article"><B>Vikas Swarup's</B> first novel was made into the Oscar Award–winning film <I>Slumdog Millionaire</I> and has been translated into over forty languages. His second novel <I>Six Suspects</I>, a murder mystery, was translated into thirty languages and is being adapted into film. Swarup has written for <I>TIME</I><I>,</I><I>Newsweek</I><I>,</I><I>The Guardian</I><I>,</I><I>The Telegraph</I><I>,</I> and <I>The Financial Times</I>. An Indian diplomat, Swarup has been posted to Turkey, the United State, Ethiopia, the UK, South Africa, and Japan. He currently lives in New Delhi, India.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Dunne Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23ea9aa9